import { Route } from "react-router-dom";
import ProtectedRoute from "../guards/ProtectedRoute";
import AdminDashboard from "../pages/adminDashboard/adminDashboard";
import SummaryReport    from "../pages/reporting/summaryreport/page";
import DailyReport      from "../pages/reporting/dailyreport/page";
import MyReports        from "../pages/reporting/myreports/page";
import AdminDailyReport from "../pages/reporting/admindailyreport/page";
import ProjectModule    from "../pages/reporting/projectmodule/page";
import WorkNature       from "../pages/reporting/worknature/page";
import Appoint        from "../pages/onboarddeboard/master/appoint/page";
import Bank           from "../pages/onboarddeboard/master/bank/page";
import Department     from "../pages/onboarddeboard/master/departments/page";
import Designation    from "../pages/onboarddeboard/master/designation/page";
import Document       from "../pages/onboarddeboard/master/document/page";
import Dashboard      from "../pages/dashboard/page";
import SprintDashboard from "../pages/dashboard/sprintdashboard/page";
import ModuleMaster   from "../pages/onboarddeboard/master/ModuleMaster/page";
import EmpInfo     from "../pages/onboarddeboard/employees/employeeInfo/page";
import Attendance  from "../pages/onboarddeboard/employees/attendance/page";
import Leave       from "../pages/onboarddeboard/employees/leave/page";
import Payroll     from "../pages/onboarddeboard/employees/payroll/page";
import Performance from "../pages/onboarddeboard/employees/performance/page";
import Ticketing from "../pages/onboarddeboard/ticketing/page"; 


import RoleAllocation from "../pages/onboarddeboard/employees/roleAllocation/page";

import LeaveCycle          from "../pages/onboarddeboard/leave/master/leaveCycle/page";
import HolidayTypes        from "../pages/onboarddeboard/leave/master/HolidayType/page";
import HolidayEntry        from "../pages/onboarddeboard/leave/master/holidayEntry/page";
import LeaveType           from "../pages/onboarddeboard/leave/master/leaveType/page";
import LeaveTypeAllotment  from "../pages/onboarddeboard/leave/master/LeaveTypeAllotment/page";

import Shift               from "../pages/onboarddeboard/leave/Shift&Authorities/Shift/page";
import Authorities         from "../pages/onboarddeboard/leave/Shift&Authorities/Authorities/page";
import AuthorityPath       from "../pages/onboarddeboard/leave/Shift&Authorities/AuthorityPath/page";

import ShiftAllotment      from "../pages/onboarddeboard/leave/ShiftManagement/ShiftAllotment/page";
import ShiftChanges        from "../pages/onboarddeboard/leave/ShiftManagement/ShiftChanges/page";

import LeaveSetup          from "../pages/onboarddeboard/leave/LeaveDetails/LeaveSetup/page";
import LeaveAllotment      from "../pages/onboarddeboard/leave/LeaveDetails/LeaveAllotment/page";


import EmployeeLeaveApplication from "../pages/onboarddeboard/leave/LeaveApplication/EmployeeLeaveApplication/page";
import LeaveApproval            from "../pages/onboarddeboard/leave/LeaveApplication/LeaveApproval/page";
import LeaveCancellation        from "../pages/onboarddeboard/leave/LeaveApplication/LeaveCancellation/page";
import CompensatoryLeaveRequest from "../pages/onboarddeboard/leave/LeaveApplication/CompensatoryLeaveRequest/page";
import CompensatoryApproval     from "../pages/onboarddeboard/leave/LeaveApplication/CompensatoryApproval/page";

// roleId: 1=SUPERADMIN, 2=ADMIN, 3=EMPLOYEE, 4=USER, 5=HR, 6=TEAM_LEAD

const adminRoutes = [

  <Route
    key="admin-dashboard"
    path="/admin-dashboard"
    element={
      <ProtectedRoute>
  <AdminDashboard />
</ProtectedRoute>
    }
  />,

  <Route
    key="reporting"
    path="/reporting"
    element={
     <ProtectedRoute>
  <AdminDashboard />
</ProtectedRoute>
    }
  >
    <Route path="summaryreport"    element={<SummaryReport />} />
    <Route path="sprintdashboard"  element={<SprintDashboard />} />
    <Route path="projectmodule"    element={<ProjectModule />} />
    <Route path="worknature"       element={<WorkNature />} />
    <Route path="dailyreport"      element={<DailyReport />} />
    <Route path="myreports"        element={<MyReports />} />
    <Route path="admindailyreport" element={<AdminDailyReport />} />
    <Route path="Dashboard"        element={<Dashboard />} />
  </Route>,

  <Route
    key="onboarddeboard"
    path="/onboarddeboard"
    element={
      <ProtectedRoute>
  <AdminDashboard />
</ProtectedRoute>
    }
  >
    <Route path="master/appoint"     element={<Appoint />} />
    <Route path="master/bank"        element={<Bank />} />
    <Route path="master/departments" element={<Department />} />
    <Route path="master/designation" element={<Designation />} />
    <Route path="master/document"    element={<Document />} />
    <Route path="master/module"       element={<ModuleMaster />} />
    <Route path="employees/list"        element={<EmpInfo />} />
    <Route path="employees/attendance"  element={<Attendance />} />
    <Route path="employees/leave"       element={<Leave />} />
    <Route path="employees/payroll"     element={<Payroll />} />
    <Route path="employees/performance" element={<Performance />} />
    <Route path="ticketing" element={<Ticketing />} />
    <Route path="system/role-allocation" element={<RoleAllocation />} />
    

    <Route path="leave/master/leave-cycle"          element={<LeaveCycle />} />
    <Route path="leave/master/holiday-types"         element={<HolidayTypes />} />
    <Route path="leave/master/holiday-entry"         element={<HolidayEntry />} />
    <Route path="leave/master/leave-type"            element={<LeaveType />} />
    <Route path="leave/master/leave-type-allotment"  element={<LeaveTypeAllotment />} />

  
    <Route path="leave/shift-authorities/shift"      element={<Shift />} />
    <Route path="leave/shift-authorities/authorities" element={<Authorities />} />
    <Route path="leave/shift-authorities/authority-path" element={<AuthorityPath />} />

    <Route path="leave/shift-management/shift-allotment" element={<ShiftAllotment />} />
    <Route path="leave/shift-management/shift-changes" element={<ShiftChanges />} />

    <Route path="leave/leave-details/leave-setup" element={<LeaveSetup />} />
    <Route path="leave/leave-details/leave-allotment" element={<LeaveAllotment />} />
    
    <Route path="leave/leave-application/apply"                element={<EmployeeLeaveApplication />} />
    <Route path="leave/leave-application/approval"              element={<LeaveApproval />} />
    <Route path="leave/leave-application/cancel"                element={<LeaveCancellation />} />
    <Route path="leave/leave-application/compensatory-request"  element={<CompensatoryLeaveRequest />} />
    <Route path="leave/leave-application/compensatory-approval" element={<CompensatoryApproval />} />

  </Route>,
  

];

export default adminRoutes;